import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import { A11y, Navigation, Pagination } from 'swiper/modules'
import { SwiperSlide } from 'swiper/react'
import { ApplicazioneCard } from '@components/molecules'
import { GenericSection, GenericSlider } from '@components/organisms'
import styles from './ApplicazioniSection.module.sass'

interface Props {
  item: MenuItemType
  theme?: GenericSectionThemeType
  editMode?: boolean
  className?: string
}

const ApplicazioniSection = (props: Props) => {
  const { item = undefined, theme = 'white', editMode = false, className = '' } = props

  return item ? (
    <GenericSection
      item={item}
      editMode={editMode}
      theme={theme}
      className={`${styles.root} ${className}`}
    >
      {editMode ? (
        <>{item.children}</>
      ) : item?.children?.length ? (
        <GenericSlider
          conf={{
            modules: [Pagination, A11y, Navigation],
            slidesPerView: 1.2,
            spaceBetween: 20,
            breakpoints: {
              576: {
                slidesPerView: 2.1,
              },
              768: {
                slidesPerView: 3,
              },
            },
            pagination: {
              enabled: true,
              clickable: true,
            },
            navigation: {
              enabled: true,
            },
          }}
          navigationPos="pagination"
          className={styles.slider}
        >
          {item.children.map((x) => (
            <SwiperSlide key={x.pk}>
              <ApplicazioneCard item={x} />
            </SwiperSlide>
          ))}
        </GenericSlider>
      ) : (
        <></>
      )}
    </GenericSection>
  ) : (
    <></>
  )
}

export default ApplicazioniSection
